import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { remove_result_l } from "../config/redux/actions/state";
import { getResultSuccess } from "../config/redux/selector";

export default function useDataResult(key) {
    const dispatch = useDispatch()
    const [state, setState] = useState()
    const result = useSelector(getResultSuccess(key));

    useEffect(() => {
        if (result) {
            setState(result.data.data)
            dispatch(remove_result_l(key))
        }
    }, [dispatch, key, result])

    return state
}